// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fB7Rg","left":"styles_left__4DfA-"};